export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var p ={
    taskId:$params.taskId,
    appId:$params.appId,
    formId:$params.formId,
    activity:$params.activity,
    ownerName:$params.taskData.ownerName
    //comment:$params.comment
  }

  PF.show('flowSecrecord',p, function(res){
    var comment = res.comment;
    let params={};
    params.isAgentRecord = 1;
    //params.action='SECRECORD';
    params.actionDescription='秘书代录：'+comment;
    params.taskId=$params.taskId;
    params.appId=$params.appId;
    params.formId=$params.formId;
    params.arActivityName='';
    if($params.taskData.taskActivityType=='notify'){
      if($params.activity.circularLeaderActivityName){
        params.arActivityName = $params.activity.circularLeaderActivityName;
      }
    }else{
      if($params.activity.leaderActivityName){
        params.arActivityName = $params.activity.leaderActivityName;
      }
    }
    if($params.extParams && $params.extParams.fullAuthType){
      params.fullAuthType = $params.extParams.fullAuthType;
    }
    params.$comment=[{id:$uuid(), content:comment, category:$params.activity.commentCategory, leading:1, isAgentRecord:1, agentType:'SECRETARY'}];
    PF.api.process.delegateSecretaryRecord(params).then((res)=>{
      $params.refreshComment(params);
    }).catch(()=>{
      $params.refreshComment(params);
    });
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-secrecord.js